import React, {Component} from 'react'
import {formatMoney} from 'accounting-js'

export default class OrderTotals extends Component {
  constructor(props){
    super(props);

    this.display_money = this.display_money.bind(this);
    this.zero_as_free = this.zero_as_free.bind(this);
  }

  display_money(int_value){
    return formatMoney(int_value / 100.0);
  }

  zero_as_free(int_value){
    if( int_value === 0){
      return "Free";
    }
    else{
      return this.display_money(int_value);
    }
  }

  render_discount(int_value){
    if(int_value == 0){
      return "—";
    }
    else{
      return (<span className="ordertotals__promotion_amount"> -{this.display_money(int_value)}</span>);
    }
  }

  render_promo_label(code, message, valid){
    if(!valid && code == ""){
      return "Promo";
    }
    else
    {
      return "Promo (" + code + ")";
    }
  }

  render_remove_balance_button(){
   let button = (
    <a className="btn btn-danger btn-sm" 
     data-disable-with='Remove'
     data-method="delete" href="/payments/remove_balance">
     Remove
    </a>
    );

    return button;
  }


  promo_display(totals){
    let disp = (<tr>
        <td className="ordertotals__label">
        Promo
        </td>
        <td className="ordertotals__money">
        {this.render_discount(totals.promo_amount)}
        </td>
      </tr>
    );

    return disp;
  }

  account_credit_display(totals){
   let disp = (<tr>
        <td className="ordertotals__label" >
          Account Balance
        </td>
        <td className="ordertotals__money">
         {this.render_remove_balance_button()}
     &nbsp;
          {this.render_discount(totals.account_credit)}
        </td>
      </tr>
      );

   if (totals.account_credit != 0){
     return disp;
   }
    else {
      return null;
    }
  }

  shipping_display(totals){

      if (this.props.totals.shipping_name){
       return ( <tr >
            <td className="ordertotals__label">
              Shipping
            </td>
            <td className="ordertotals__money">
        {totals.shipping_name + ":  "} <span className="ordertotals__shipping_cost">{this.zero_as_free(totals.shipping)}</span>
            </td>
          </tr>
          );
        }
  }

  tax_display(totals){
    let tax_row = (
      <tr>
      <td className="ordertotals__label">
      Taxes (OH)
      </td>
      <td className="ordertotals__money">
      {this.display_money(totals.tax)}
      </td>
      </tr>
    );

    if (totals.tax != 0){
      return tax_row;
    }
    else
    {
      return null;
    }
  }

  render(){
    let totals = this.props.totals;


    return (
      <table className="table ordertotals">
        <thead>
          <tr>
            <th>
            </th>
            <th>
            </th>
            <th style={{width: "74px"}}></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="ordertotals__label">
              Subtotal
            </td>
            <td className="ordertotals__money">
              {this.display_money(totals.sub_total)}
            </td>
      <td></td>
          </tr>
          {this.promo_display(totals)}
          {this.shipping_display(totals)}

          {this.tax_display(totals)}
        </tbody>
        <tfoot>
         {this.account_credit_display(totals)}
          <tr>
            <td className="ordertotals__label" >
              Total
            </td>
            <td className="ordertotals__money">
              {this.display_money(totals.total)}
            </td>
          </tr>
        </tfoot>
      </table>
    );
  }
}
